import { render, staticRenderFns } from "./NavOverlayItemChild.vue?vue&type=template&id=6e5125a4&"
import script from "./NavOverlayItemChild.vue?vue&type=script&lang=js&"
export * from "./NavOverlayItemChild.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports